import { createFileRoute } from "@tanstack/react-router";

import { LegalHomeButton } from "@/components/legal-home-button";

const privacyPolicyUrl =
  "https://legally-snippet.legal-cdn.com/v1/public/websites/SvHU2CVl6KSNpDJGkcYkpVpPCbMiy6/policies/latest/iframe.html";

export const Route = createFileRoute("/datenschutz")({
  staticData: { sitemap: true },
  head: () => ({
    meta: [
      { title: "Datenschutzerklärung. Begner" },
      {
        name: "description",
        content: "Datenschutzerklärung von Begner zur Bearbeitung personenbezogener Daten.",
      },
    ],
  }),
  component: PrivacyPolicyPage,
});

function PrivacyPolicyPage() {
  return (
    <main className="bg-background">
      <section className="border-b border-border/70 bg-surface">
        <div className="container-page flex flex-col items-start justify-between gap-5 py-6 sm:flex-row sm:items-center">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-deep">
              Rechtliches
            </p>
            <h1 className="mt-2 font-display text-2xl font-extrabold tracking-tight sm:text-3xl">
              Datenschutzerklärung
            </h1>
            <p className="mt-2 text-sm font-medium text-foreground">Stand: 18. Oktober 2026</p>
          </div>
          <LegalHomeButton />
        </div>
      </section>
      <section className="border-b border-border/70 bg-background">
        <div className="container-page py-8 sm:py-10">
          <div className="max-w-4xl rounded-2xl border border-border bg-surface p-6 sm:p-8">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-brand-deep">
              Ergänzende Datenschutzinformation
            </p>
            <h2 className="mt-3 font-display text-2xl font-bold">
              Meta Pixel (Marketing, nur mit Einwilligung)
            </h2>
            <div className="mt-4 space-y-4 text-sm leading-relaxed text-muted-foreground">
              <p>
                Auf dieser Website verwenden wir nach Ihrer ausdrücklichen Einwilligung den Meta
                Pixel des Anbieters Meta Platforms Ireland Limited, Merrion Road, Dublin 4, D04
                X2K5, Irland. Unsere Pixel-ID lautet 1404850441754094. Ohne Ihre Einwilligung wird
                der Meta Pixel nicht geladen.
              </p>
              <p>
                Der Meta Pixel hilft uns, Aufrufe öffentlicher Seiten zu messen, die Wirksamkeit
                unserer Werbung auf Facebook und Instagram auszuwerten und Werbekampagnen zu
                optimieren. Anmelde-, Registrierungs-, Konto-, Verwaltungs-, Bestätigungs- und
                Rechnungsseiten sind von dieser Seitenaufrufmessung ausgenommen. Dabei können
                insbesondere die aufgerufene Seite, Referrer-Informationen, Zeitpunkt des Aufrufs,
                Browser- und Geräteinformationen, die IP-Adresse sowie von Meta gesetzte Kennungen
                verarbeitet werden. Meta kann diese Daten mit einem bestehenden Facebook- oder
                Instagram-Konto verknüpfen.
              </p>
              <p>
                Eine Verarbeitung oder Übermittlung von Daten in die USA kann nicht ausgeschlossen
                werden. Rechtsgrundlage ist Ihre Einwilligung, soweit die DSGVO anwendbar ist Art. 6
                Abs. 1 lit. a DSGVO. Sie können Ihre Entscheidung jederzeit über
                „Cookie-Einstellungen“ im Footer mit Wirkung für die Zukunft ändern. Beim Widerruf
                werden keine weiteren Ereignisse an Meta gesendet.
              </p>
              <p>
                Weitere Informationen finden Sie in der{" "}
                <a
                  href="https://www.facebook.com/privacy/policy/"
                  target="_blank"
                  rel="noreferrer"
                  className="font-semibold text-primary underline-offset-4 hover:underline"
                >
                  Datenschutzrichtlinie von Meta
                </a>{" "}
                und in der{" "}
                <a
                  href="https://www.facebook.com/privacy/policies/cookies/"
                  target="_blank"
                  rel="noreferrer"
                  className="font-semibold text-primary underline-offset-4 hover:underline"
                >
                  Cookie-Richtlinie von Meta
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="border-b border-border/70 bg-background">
        <div className="container-page py-8 sm:py-10">
          <div className="max-w-4xl rounded-2xl border border-border bg-surface p-6 sm:p-8">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-brand-deep">
              Ergänzende Information zur Auftragsvermittlung
            </p>
            <h2 className="mt-3 font-display text-2xl font-bold">
              Ihre Auswahl steuert die Kontaktfreigabe
            </h2>
            <div className="mt-4 space-y-4 text-sm leading-relaxed text-muted-foreground">
              <p>
                Öffentliche Auftragsangaben enthalten keine von Begner hinterlegten privaten
                Telefonnummern oder E-Mail-Adressen. Firmen können während der Sammelfrist Interesse
                bekunden. Nur bis zu fünf von Ihnen ausdrücklich ausgewählte Firmen erhalten Zugriff
                auf Ihre hinterlegten Kontaktdaten für diesen Auftrag. Auch ein kostenpflichtiges
                Firmenkonto erhält ohne Ihre Auswahl keinen Zugriff.
              </p>
              <p>
                Für diesen Ablauf speichern wir Interessebekundungen, Ihre Auswahl, Zeitpunkte von
                Freigaben und Kontaktabrufen sowie zugehörige Mitteilungen. E-Mail-Mitteilungen
                verweisen auf das geschützte Konto und enthalten keine hinterlegten privaten
                Kontaktdaten. Interessen werden per E-Mail gebündelt zusammengefasst; Entscheidungen
                und wichtige Fristen werden gesondert mitgeteilt.
              </p>
              <p>
                Sie können einen weiteren Kontaktabruf für eine ausgewählte Firma sperren und eine
                unerwünschte Kontaktaufnahme melden. Bereits von der Firma eingesehene Daten werden
                dadurch nicht zurückgeholt. Die nachfolgende Datenschutzerklärung beschreibt die
                weiteren Bearbeitungen, eingesetzten Dienstleister und Ihre Kontaktmöglichkeiten.
              </p>
            </div>
          </div>
        </div>
      </section>
      <iframe
        src={privacyPolicyUrl}
        title="Datenschutzerklärung von Begner"
        className="block min-h-[75vh] w-full border-0 bg-background"
        style={{ height: "calc(100vh - 12rem)" }}
      />
    </main>
  );
}
